import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';
import * as React from 'react';
import TeamCapacity from './TeamCapacityGraph';
import TradeCapacity from './TradeCapacityGraph';
import TradepersonCapacity from './TradepersonCapacityGraph';
import ShiftCapacity from './ShiftCapacityGraph';
import { ThemeContext } from '../../../context/theme.context';
interface IProps {}
interface IState {}
class TabPane extends React.Component<IProps, IState> {
  private headerText: any;
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  private tabObj: TabComponent;
  constructor(props: IProps) {
    super(props);
    this.headerText = [
      { text: 'Team' },
      { text: 'Trade' },
      { text: 'TradesPerson' },
      { text: 'Shift' },
    ];
    this.tabObj = new TabComponent(props);
  }
  content0() {
    return (
      <div className='row mt-3 p-2'>
        <div className='col-md-12'>
          <TeamCapacity />
        </div>
      </div>
    );
  }
  content1() {
    return (
      <div className='row mt-3 p-2'>
        <div className='col-md-12'>
          <TradeCapacity />
        </div>
      </div>
    );
  }
  content2() {
    return (
      <div className='row mt-3 p-2'>
        <div className='col-md-12'>
          <TradepersonCapacity />
        </div>
      </div>
    );
  }
  content3() {
    return (
      <div className='row mt-3 p-2'>
        <div className='col-md-12'>
          <ShiftCapacity />
        </div>
      </div>
    );
  }
  componentDidUpdate() {
    if (this.context.isChangeTabPane) {
      this.context.setChangeTabPane(false);
    }
  }
  render() {
    return (
      <TabComponent
        heightAdjustMode='Auto'
        ref={(el) => {
          this.tabObj = el as TabComponent;
        }}
        statelessTemplates={['directiveTemplates']}
      >
        <TabItemsDirective>
          <TabItemDirective
            header={this.headerText[0]}
            content={this.content0}
          />
          <TabItemDirective
            header={this.headerText[1]}
            content={this.content1}
          />
          <TabItemDirective
            header={this.headerText[2]}
            content={this.content2}
          />
          <TabItemDirective
            header={this.headerText[3]}
            content={this.content3}
          />
        </TabItemsDirective>
      </TabComponent>
    );
  }
}
export default TabPane;
